// Status tag wording. A work authorization document only has its integrity
// checked; that says nothing about whether the person is authorized to work,
// so those fields name the document's integrity instead of a plain "Verified".
export const verificationTagText = ({ documentCheck = false } = {}) =>
  documentCheck
    ? { verifiedText: 'Document integrity verified', notVerifiedText: 'Document integrity not verified' }
    : { verifiedText: 'Verified', notVerifiedText: 'Not verified' };
